<div class="container">
  <div class="main-div">
    <div class="center-pane">
      <div class="form-div">
        <div class="header">
          <div class="logo">
            <img src="assets/logo-full.svg"/>
          </div>
          <!--          <h2 i18n="@@merchantLoginTitle">Login to your account as:</h2>-->
          <h2 i18n="@@loginPageTitle">Login to your account as a:</h2>
          <div class="tabs-container">
            <nav class="nav nav-pills">
              <p (click)="loginType = 'customer'"
                 [ngClass]="isActive('customer')"
                 aria-current="page"
                 class="nav-link" i18n="@@customer">
                Customer
              </p>
              <p (click)="loginType = 'merchant'"
                 [ngClass]="isActive('merchant')"
                 class="nav-link" i18n="@@restraunt">
                Restaurant
              </p>
            </nav>
          </div>
          <p *ngIf="warningMessage?.hasActualValue()">{{warningMessage}}</p>
        </div>
        <!-- emailItem -->
        <input-text-field (onchange)="updateInputFieldById('email', $event)"
                          [errorHandling]="errorHandling"
                          [floatingLabel]="emailLabel"
                          [group]="signInForm"
                          [id]="'email'"
                          [inputType]=InputType.email
                          [validators]=[Validators.required,Validators.email]
        ></input-text-field>
        <!-- PasswordItem -->
        <input-text-field (onchange)="updateInputFieldById('password', $event)"
                          [errorHandling]="errorHandling"
                          [floatingLabel]="passwordLabel"
                          [group]="signInForm"
                          [id]="'password'"
                          [inputType]=InputType.password
                          [validators]=[Validators.required]>
        </input-text-field>
        <div class="forget-password">
          <button (click)=" onForgotPassword()" class="forget-password-button btn" i18n="@@forgotPasswordTitle">Forgot
            password?
          </button>
        </div>
        <div *ngIf="serverError !== null"
             class="alert alert-danger form-alert">{{ serverError }}
        </div>
        <primary-button
          (onClick)="onLoginSubmitted()"
          [loading]="isLoading"
          [showArrow]="true"
          [title]="loginLabel">
        </primary-button>
        <div class="text-center">
          <p i18n="@@dontHaveAccount">Don't have an account? <a [routerLink]="goToSignup()" class="sign-up">Sign up</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
